/**
 * Script para probar específicamente el servicio de inventario
 */

export const testInventoryService = async () => {
  try {
    console.log('🔧 === PROBANDO SERVICIO DE INVENTARIO ===');
    
    // 1. Importar el servicio
    console.log('📦 Importando inventoryService...');
    const inventoryService = (await import('../services/inventoryService')).default;
    console.log('✅ inventoryService importado correctamente');
    
    // 2. Probar getCategories
    console.log('\n📂 Probando getCategories...');
    const categories = await inventoryService.getCategories();
    console.log(`✅ Categorías obtenidas: ${categories.length}`);
    console.log('📋 Categorías:', categories.map(cat => `${cat.name} (enabled: ${cat.enabled})`));
    
    // 3. Probar getProductsFromDocumentedStructure
    console.log('\n📦 Probando getProductsFromDocumentedStructure...');
    const products = await inventoryService.getProductsFromDocumentedStructure();
    console.log(`✅ Productos obtenidos: ${products.length}`);
    
    if (products.length > 0) {
      console.log('📋 Primeros 3 productos:');
      products.slice(0, 3).forEach((product, index) => {
        console.log(`  ${index + 1}. ${product.name} (SKU: ${product.sku})`);
        console.log(`     - Categoría: ${product.category}`);
        console.log(`     - Imagen: ${product.imageURL || 'No disponible'}`);
        console.log(`     - Variantes: ${(product as any).variants?.length || 0}`);
      });
    } else {
      console.log('⚠️ No se encontraron productos');
    }
    
    // 4. Probar getBrands
    console.log('\n🏷️ Probando getBrands...');
    const brands = await inventoryService.getBrands();
    console.log(`✅ Marcas obtenidas: ${brands.length}`);
    
    // 5. Probar getSuppliers
    console.log('\n🏢 Probando getSuppliers...');
    const suppliers = await inventoryService.getSuppliers();
    console.log(`✅ Proveedores obtenidos: ${suppliers.length}`);
    
    console.log('\n✅ === PRUEBA COMPLETADA ===');
    
    return {
      success: true,
      categories: categories.length,
      products: products.length,
      brands: brands.length,
      suppliers: suppliers.length,
      productsData: products.slice(0, 3)
    };

  } catch (error) {
    console.error('❌ Error probando servicio:', error);
    return {
      success: false,
      error: error
    };
  }
};

// Hacer disponible en consola
if (typeof window !== 'undefined') {
  (window as any).testInventoryService = testInventoryService;
}